module.exports = __webpack_public_path__ + "img/brand-01.881d99d3.png";